// mui
import { Button, Stack } from '@mui/material';

// components
import { BottomSheetDialog } from '@/pwa/atoms/BottomSheetDialog/BottomSheetDialog';

export interface ContactSheetProps {
  isOpen: boolean;
  onClose: () => void;
  phone?: string | null;
  email?: string | null;
}

export const ContactSheet = ({
  isOpen,
  onClose,
  phone,
  email,
}: ContactSheetProps) => (
  <BottomSheetDialog isOpen={isOpen} onClose={onClose} aboveModal>
    <Stack spacing={2}>
      {phone && (
        <Button variant='outlined' fullWidth size='large' href={`tel:${phone}`}>
          Call {phone}
        </Button>
      )}
      {email && (
        <Button
          variant='outlined'
          fullWidth
          size='large'
          href={`mailto:${email}`}
        >
          Email them
        </Button>
      )}
    </Stack>
  </BottomSheetDialog>
);

ContactSheet.displayName = 'ContactSheet';

export default ContactSheet;
